export enum VideoType {
    Trailer = 'Trailer',
    Teaser = 'Teaser',
    Clip = 'Clip',
    Featurette = 'Featurette',
    Opening_Credits = 'Opening Credits',
    Behind_the_Scenes = 'Behind the Scenes',
    Bloopers = 'Bloopers'
}
